import { mdiWeb } from '@mdi/js'
import { useIntl } from 'react-intl'

import { useAppSelector } from 'app/hooks'
import {
  currentRootDomainIdSelector,
  rootDomainByIdSelector,
} from 'features/rootDomains/selectors'
import { domainsSelectorMessages } from '../messages'
import {
  NavToRootDash,
  NavToRootIcon,
  NavToRootLink,
  StyledDomainsNavToRoot,
} from './styles'
import { useLocation } from 'react-router-dom'

interface DomainsNavToRootProps {
  isDisabled?: boolean
}

function DomainsNavToRoot(props: DomainsNavToRootProps) {
  const { formatMessage } = useIntl()
  const { pathname } = useLocation()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const currentRootDomain = useAppSelector(
    rootDomainByIdSelector(currentRootId)
  )

  return (
    <StyledDomainsNavToRoot>
      <NavToRootLink
        to={pathname}
        $disabled={props.isDisabled}
        title={formatMessage(domainsSelectorMessages.backToRoot, {
          rootDomainName: currentRootDomain?.name,
        })}
      >
        <NavToRootIcon path={mdiWeb} size={1} $disabled={props.isDisabled} />
      </NavToRootLink>
      <NavToRootDash>/</NavToRootDash>
    </StyledDomainsNavToRoot>
  )
}

export default DomainsNavToRoot
